if (!customElements.get('app-hotspot')) {
  class Hotspot extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        trigger: '[app-trigger]',
        tooltip: '[app-tooltip]',
        closeBtn: '[app-close]',
        container: '[app-hotspots-container]',
      };
    }

    connectedCallback() {
      this.container = this.closest(this.selectors.container);
      this.trigger = this.querySelector(this.selectors.trigger);
      this.tooltip = this.querySelector(this.selectors.tooltip);
      this.closeBtn = this.querySelector(this.selectors.closeBtn);

      this.attachHandlers();
    }

    attachHandlers() {
      this.trigger.addEventListener('click', this.triggerTooltip.bind(this));
      this.closeBtn.addEventListener('click', this.closeTooltip.bind(this));
      window.addEventListener('resize', this.calculateBounds.bind(this));
      window.addEventListener('load', this.calculateBounds.bind(this));
    }

    calculateBounds() {
      const { x: tooltipX, width: tooltipWidth } =
        this.tooltip.getBoundingClientRect();
      const SCROLLBAR_WIDTH = 17;

      if (tooltipX + tooltipWidth + SCROLLBAR_WIDTH > window.innerWidth) {
        this.tooltip.style.left = `${-1 * tooltipWidth}px`;
      }
    }

    triggerTooltip(e) {
      !this.getAttribute('open') ? this.openTooltip() : this.closeTooltip();
    }

    openTooltip() {
      if (this.getAttribute('open')) {
        this.closeTooltip();
        return;
      }

      this.closeSiblings(this);
      this.setAttribute('open', true);
    }

    closeTooltip() {
      this.removeAttribute('open');
    }

    closeSiblings(hotspot) {
      const siblings = Array.from(
        hotspot.container.querySelectorAll('app-hotspot'),
      );
      siblings.forEach((sibling) => {
        if (sibling !== hotspot) {
          sibling.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('app-hotspot', Hotspot);
}
